// Formato de montos y porcentajes de Formación de Precios.

export function fmt(n: number | null | undefined) {
  if (n == null || isNaN(n)) return '—';
  return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 0 }).format(n);
}

export function fmtCosto(n: number | null | undefined) {
  if (n == null || isNaN(n)) return '—';
  return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
}

export function fmtDiferenciaPct(n: number | null | undefined) {
  if (n == null || isNaN(n)) return '—';
  return `${n > 0 ? '+' : ''}${n.toLocaleString('es-AR', { maximumFractionDigits: 2 })}%`;
}

export function fmtPorcentaje(n: number | null | undefined) {
  if (n == null || isNaN(n)) return '—';
  return `${n.toLocaleString('es-AR', { maximumFractionDigits: 3 })}%`;
}
